import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { MessageConstant } from "@app/constant/message.constant";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = MessageConstant.appTitle;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title) { }

  ngOnInit() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const routeObj = this.getChild(this.route);
        routeObj.data.subscribe((data: any) => this.titleService.setTitle(data.title));
      });
  }

  getChild(route: ActivatedRoute) {
    return route.firstChild ? this.getChild(route.firstChild) : route;
  }

}
